import style from "styled-components";
import { Link } from "react-router-dom";

export const CartContainer = style(Link)`
    display: flex;
    flex-direction: row;
    border: 2px solid black;
    padding:0.2rem;
    margin: 1rem;
    text-decoration: none;
    color: black;
@media(max-width:800px){
    background:transparent;
    color:white;
  }
`;
export const CartContainerImage = style.img`
width: 1.5rem;
`;

export const CartContainerButton = style.h1`
    font-size: 1rem;
    margin: 0.2rem;
    margin-top: 0.8rem;
    cursor:pointer;
`;
